import { watchlistSignals } from "../../../constants";
import { getScreeningOutcomeItems } from "../../../helpers"

export const getWatchlistData = (contentData) => {
  return {
    fakeEmailDomains: getScreeningOutcomeItems(contentData, "watchlist.fakeEmailDomains"),
    fakeAffiliationNames: getScreeningOutcomeItems(contentData, "watchlist.fakeAffiliationNames"),
    fakeNamesOrEmailAddresses: getScreeningOutcomeItems(contentData, "watchlist.fakeNamesOrEmailAddresses"),
    disposableEmailDomains: getScreeningOutcomeItems(contentData, "watchlist.disposableEmailDomains"),
    suspectArticles: getScreeningOutcomeItems(contentData, "watchlist.suspectArticles"),
    metadataSuspects: getScreeningOutcomeItems(contentData, "watchlist.metadataSuspects"),
    manuscriptsOfferedForSale: getScreeningOutcomeItems(contentData, "watchlist.manuscriptsOfferedForSale"),
  };
};

export const formatScreeningOutcomeHits = (screeningOutcomes) => {
  if (!screeningOutcomes) return null;
  const labelMap = watchlistSignals.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const formattedStatus = screeningOutcomes
    .map(({ type, items }) => {
      const label = labelMap[type];
      return label ? `${label}&nbsp;(x${items.length})` : null;
    })
    .join("<br>");

  return formattedStatus;
};

export const formatScreeningOutcomeHitsPlainText = (screeningOutcomes) => {
  if (!screeningOutcomes) return "";
  const labelMap = watchlistSignals.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const formattedStatus = screeningOutcomes
    .map(({ type, items }) => {
      const label = labelMap[type];
      return label ? `${label} (x${items.length})` : null;
    })
    .filter(Boolean)
    .join("\n");

  return formattedStatus;
};
